export enum Routes {
  Login = '/',
  Docs = '/docs/*',
  Website = '/website/*',
  LoginSSO = '/login',
  PaymentsSuccess = '/payment-success',
  PaymentsError = '/payment-failure',
  OAuthPopup = '/callback',
  Maintenance = '/maintenance',
  RegisterTecnicalPage = '/callback-register',
  ResetPasswordTecnicalPage = '/callback-forgot-password',
  ConfigurePlatform = '/configuration',
  Homepage = '/homepage',
  Settings = '/settings',
  Departments = '/departments',
  Department = '/department',
  Team = '/team',
  TeamEmployeeDetails = '/team/employee/:employeeId',
  DepartmentTeamDetails = '/department/team/:teamId',
  DepartmentEmployeeDetails = '/department/employee/:employeeId',
  DepartmentsDetail = '/departments/:departmentId',
  DepartmentsTeamsDetail = '/departments/:departmentId/teams/:teamId',
  People = '/people',
  PeopleImport = '/people/import',
  PeopleReview = '/people/review',
  PeopleDetail = '/people/:peopleId',
  Surveys = '/surveys',
  SurveyDetail = '/surveys/:surveyId',
  SurveySimulate = '/surveys/:surveyId/simulate',
  SurveyDetailsStats = '/surveys/:surveyId/campaign/:campaignId/stats',
  SurveyToComplete = '/survey/:campaignId',
  AiPlayground = '/training/ai-playground',
  TrainingSoftSkills = '/training/soft-skills',
  TrainingSoftSkillsMyContents = '/training/soft-skills/my-contents',
  TrainingSoftSkillsSpecificContents = '/training/soft-skills/:contentType',
  TrainingHardSkills = '/training/hard-skills',
  TrainingHardSkillsMyContents = '/training/hard-skills/my-contents',
  TrainingHardSkillsSpecificContents = '/training/hard-skills/:contentType',
  Profile = '/profile',
  // PAYMENTS
  Payments = '/settings/payments',
  // CONVERSATIONS
  Conversations = '/conversations',
  Conversation = '/conversation/:conversationId',
  // QUIZ
  Quiz = '/quiz/:quizId/:submissionId',
  // VIDEO
  Video = '/training/hard-skills/video/:videoId',
  // DOCUMENT
  Document = '/training/hard-skills/document/:documentId',
  // ASSESSMENTS
  Assessments = '/assessments',
  AssessmentDetail = '/assessments/:templateId',
  // REPORTS
  ReportsAssessments = '/reports/assessments',
  ReportsTrainings = '/reports/trainings',
  // INVITATIONS FLOW
  SetPassword = '/set-password',
  ConfirmEmail = '/confirm-email',
}
